import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { applyQueryDefaults } from 'utils/applyQueryDefaults';

export function useRouterQuery() {
  const router = useRouter();

  return useMemo(() => applyQueryDefaults(router.query), [router.query]);
}
